import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
// Mui
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import { useTheme } from '@mui/material/styles';
// Service
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import { apiGetCurrentUser } from 'api/UserApi';
import RacingService from 'services/RacingService';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { Height } from '@mui/icons-material';

const AccountSettingsContainer = styled(Grid)(({ theme }) => ({
    minHeight: '550px',
    '.MuiTypography-h3': {
        margin: '20px 0px 20px 0px',
        //color: '#fff',
        fontSize: '22px'
    },
    '.mainContainer': {
        border: '1px solid rgba(255,255,255,0.5)',
        borderRadius: '6px',
        display: 'flex',
        margin: '0px',
        width: 'calc(100%)',
        padding: '10px',
        table: {
            [theme.breakpoints.down('sm')]: {
                thead: { display: 'block' },
                'thead tr': {
                    position: 'absolute',
                    top: '-9999px',
                    left: '-9999px'
                },
                td: {
                    border: 'none',
                    // borderBottom: '1px solid #eee',
                    borderBottom: '1px solid rgba(255,255,255,0.2)',
                    position: 'relative',
                    paddingLeft: '50% !important',
                    whiteSpace: 'normal',
                    textAlign: 'left',
                    display: 'block',
                    height: '44px'
                },

                'td:before': {
                    content: 'attr(data-title)'
                },
                'tbody tr': {
                    display: 'block',
                    borderBottom: '1px solid rgba(255,255,255,0.5)'
                },

                'td::before': {
                    position: 'absolute',
                    top: '9px',
                    left: '6px',
                    width: '45%',
                    paddingRight: '10px',
                    whiteSpace: 'nowrap',
                    textAlign: 'left'
                }
            }
        },

        '.leftContainer': {
            padding: '24px',
            '.MuiTypography-h4': {
                fontSize: '20px',
                color: '#fff',
                marginBottom: '8px'
            }
        },
        '.rightContainer': {
            borderLeft: '1px solid rgba(255,255,255,0.5)',
            ul: {
                padding: '0px',
                margin: '0px',
                listStyle: 'none',
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                li: {
                    display: 'flex',
                    alignItems: 'center',
                    height: '50px',
                    justifyContent: 'space-between',
                    width: '100%',
                    padding: '10px 20px',
                    borderBottom: '1px solid rgba(255,255,255,0.5)'
                }
            }
        },
        '.MuiTableCell-root ': { padding: '10px 16px' },
        '.MuiTableCell-head': { backgroundColor: theme.palette.secondary.main },
        '.MuiOutlinedInput-input': { color: '#fff' }
    }
}));

// Define the type for a transaction
interface Transaction {
    transactionTypeRefId: number;
    transactionType: string;
    createdAt: string;
    postBalance: number;
    income: number | null;
    expense: number | null;
    gameResult: string;
}

//user/transaction/list
const MyActivity = () => {
    const theme = useTheme();
    // const [transactions, setTransactions] = useState<Transaction[]>([]);
    const [pageSize, setPageSize] = useState<number>(10);
    const [page, setPage] = useState<number>(0);
    const [rows, setRows] = useState<Transaction[]>([]);
    const [rowCount, setRowCount] = useState<number>(0);
    useEffect(() => {
        const getTransactions = async () => {
            const params = {
                page: page + 1,
                limit: pageSize
            };
            const response = await RacingService.getTransactions(params);
            const jsonData = response.data.data.body;
            setRowCount(jsonData.totalItems);
            setRows(jsonData.data);
        };
        getTransactions();
    }, [page, pageSize]);
    const handlePageChange = (newPage: number) => {
        setPage(newPage);
    };

    const handlePageSizeChange = (event: SelectChangeEvent<number>) => {
        setPageSize(event.target.value as number);
        setPage(0);
    };
    const startItem = page * pageSize + 1;
    const endItem = Math.min((page + 1) * pageSize, rowCount);
    const seq_page = page * pageSize;

    return (
        <AccountSettingsContainer>
            <Grid container>
                <Grid item xs={12}>
                    <Typography
                        variant="h3"
                        sx={{
                            color: theme.palette.secondary.main,
                            [theme.breakpoints.down('sm')]: {
                                fontSize: '18px !important'
                            }
                        }}
                    >
                        My Activity
                    </Typography>
                </Grid>
            </Grid>
            <Grid container className="mainContainer">
                <TableContainer sx={{ background: '#050505' }} component={Paper}>
                    <Table sx={{}} aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ color: theme.palette.grey[500], fontWeight: '800 !important' }} align="left">
                                    Sno
                                </TableCell>
                                <TableCell sx={{ color: theme.palette.grey[500], fontWeight: '800 !important' }} align="left">
                                    Transaction Id
                                </TableCell>
                                <TableCell sx={{ color: theme.palette.grey[500], fontWeight: '800 !important' }} align="left">
                                    Type
                                </TableCell>
                                <TableCell sx={{ color: theme.palette.grey[500], fontWeight: '800 !important' }} align="left">
                                    Transaction Date
                                </TableCell>
                                <TableCell sx={{ color: theme.palette.grey[500], fontWeight: '800 !important' }} align="right">
                                    Balance Before
                                </TableCell>
                                <TableCell sx={{ color: theme.palette.grey[500], fontWeight: '800 !important' }} align="right">
                                    Income
                                </TableCell>
                                <TableCell sx={{ color: theme.palette.grey[500], fontWeight: '800 !important' }} align="right">
                                    Expense
                                </TableCell>
                                <TableCell sx={{ color: theme.palette.grey[500], fontWeight: '800 !important' }} align="right">
                                    Balance After
                                </TableCell>
                                <TableCell sx={{color: theme.palette.grey[500], fontWeight: '800 !important' }} align="right">
                                    Result
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>
                                <TableCell data-title="Sno" align="left">
                                    1
                                </TableCell>
                                <TableCell data-title="Transaction Id" align="left">
                                    ABCDEF
                                </TableCell>
                                <TableCell data-title="Type" align="left">
                                    DEPOSIT
                                </TableCell>
                                <TableCell data-title="Transaction Date" align="left">
                                    Oct 16th 2024
                                </TableCell>
                                <TableCell data-title="Balance Before" align="right">
                                    1000
                                </TableCell>
                                <TableCell data-title="Income" align="right">
                                    100
                                </TableCell>
                                <TableCell data-title="Expense" align="right">
                                    50
                                </TableCell>
                                <TableCell data-title="Balance After" align="right">
                                    900
                                </TableCell>
                                <TableCell data-title="Result" align="right">
                                    WON
                                </TableCell>
                            </TableRow>{' '}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>
        </AccountSettingsContainer>
    );
};

export default MyActivity;
